import { IFilter } from "../shared/ifilter";
import { ICMetaDescription } from "../entities/icmetadescription";

export class ICMetaDescriptionFilter implements IFilter<ICMetaDescription> {
  AreaIds: number[];
  Combine: boolean;
  Count: number;
  CurrentPage: number;
  Levels: number[];
  OnlyEditable: boolean;
  PerPage: number;
  Sort: number;
  SortType: number;
  UsePagination: boolean;
  SearchQuery: string;

  TypeId: number;

  constructor(data?: Partial<ICMetaDescriptionFilter>) {
    Object.assign(this, data);
  }
}
